import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { initI18n, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "@/i18n";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Determine language from URL path BEFORE React renders
const getLanguageFromURL = () => {
  const segments = window.location.pathname.split('/').filter(Boolean);
  if (segments.length > 0 && SUPPORTED_LANGUAGES.includes(segments[0])) {
    return segments[0];
  }
  return DEFAULT_LANGUAGE;
};

const lang = getLanguageFromURL();
document.documentElement.lang = lang;

// Wait for the active language's resource chunk to load before rendering,
// so hydration content matches the prerendered markup instead of briefly
// showing raw translation keys.
initI18n(lang).then(() => {
  const rootElement = document.getElementById("root");

  // Support prerendering: hydrate existing markup instead of discarding it.
  // createRoot() on a container that already has server/prerendered children
  // wipes that content and forces a full client-side re-render, which is what
  // was delaying LCP on prerendered routes.
  if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(
      rootElement,
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }

  // Register service worker for PWA functionality
  serviceWorkerRegistration.register({
    onSuccess: () => console.log('✅ PWA: Content cached for offline use'),
    onUpdate: (registration) => console.log('🔄 PWA: New version available', registration),
  });
});
